import moment from 'moment';
import { getMonthNumber } from '../../../utils/helpers/getMonthNumber';

const months = [
  'JAN',
  'FEB',
  'MAR',
  'APR',
  'MAY',
  'JUN',
  'JUL',
  'AUG',
  'SEP',
  'OCT',
  'NOV',
  'DEC',
];

export const getListMonthly = (year: any) => {
  const getYear = new Date(year).getFullYear();

  return months.map((month) => ({
    month_year: `${month}-${getYear}`,
    created_date: moment(
      `01/${getMonthNumber(month)}/${getYear}`,
      'DD/MM/YYYY'
    ),
  }));
};

export const getColumnLength = (monthYear: string) => {
  if (!monthYear) return 0;
  const monthAndYear = monthYear.split('-');
  const month = getMonthNumber(monthAndYear[0]);
  const year = monthAndYear[1];

  return moment(`${year}-${month}`, 'YYYY-MM').daysInMonth();
};
